import * as React from 'react';
import { WarningBox } from '../../shared/WarningBox';

export const WorksheetScidsOverrideWarning = () => (
  <WarningBox
    message="The SCIDs for this worksheet have been manually overridden. Please ensure that the appropriate
    SCIDs have been used."
  />
);
